import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import ButtonSubmit from "../common/buttonSubmit";
import ButtonWhite from "../common/buttonWhite";
import CheckboxLabel from "../common/checkboxLabel";
import AlertMessage from "../alertMessage";
import { isGroupLinkParent } from "../../utils/helpers";

const PopUpDeleteTimeslotByService = (props: any) => {
  const { t } = useTranslation();
  let show = props.show ?? false;
  const [checkDelete, setCheckDelete] = useState(true);
  let id = props.id ?? null
  const { categoryPrenotation } = useSelector((state: any) => state.timeslot)
  let category = categoryPrenotation.find((category: any) => category._id == id);

  const alertMessage = isGroupLinkParent(category?.groupLink) ? t('timeslot.linked-parent-delete-message') : '';

  useEffect(() => {
    setCheckDelete(true);
  }, [id])

  return (
    <Modal show={show} onHide={props.closeModal}>
      <Modal.Header closeButton>
        <Modal.Title>Elimina</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="col-lg-12">
          {alertMessage && <AlertMessage description={alertMessage} />}

          {((category) ?
            <p>Eliminando tutte le fasce orarie del servizio {'\n'}{category?.name}:</p>
            :
            <p>Eliminando tutte le fasce orarie </p>
          )}
          <p>
          </p>
          <ul>
            <li>
              <b>Cancellerai tutte le fasce orarie</b> future non prenotate
            </li>
            <li>
              <b>Cancellerai tutte le fasce</b> orarie passate
            </li>
            <li>
              Le prenotazioni effettuate rimarranno attive
            </li>
            <li>
              In caso di cancellazione prenotazione, non sarà possibile riassegnare la prenotazione.
            </li>
          </ul>
          <CheckboxLabel toggleClick={setCheckDelete} title="Sono consapevole che questa azione non può essere annullata" />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <>
          <ButtonWhite textButton={t('cancel')} handleChange={() => (setCheckDelete(true), props.handleCloseSecondary())} />
          <ButtonSubmit disabled={checkDelete} textButton={t('delete')} handleChange={() => (setCheckDelete(true), props.handleClosePrimary())} />
        </>
      </Modal.Footer>
    </Modal>
  )
}
export default PopUpDeleteTimeslotByService